import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BankService } from './administration/bank.service';
import { SignalRFacadeService } from './signal-r-facade.service';
import { SignalRService } from 'app/core/services/signal-r.service';
import { AdvanceSearchStateService } from './advance-search-state.service';
import { QualificationApiService } from 'app/core/services/qualification-api.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    BankService,
    SignalRFacadeService,
    SignalRService,
    QualificationApiService,
    AdvanceSearchStateService
  ]
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts